import {Injectable, Injector} from "@angular/core";
import {CustomObjectAssociationContext, CustomObjectTypeSearchModel} from "./custom-object-type-search.model";

@Injectable()
export class OutletCustomObjectTypeSearchModel extends CustomObjectTypeSearchModel {
    constructor(injector: Injector) {
        super(injector);
        this.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.OUTLET;
    }

    override getResource(): string {
        return "custom-outlet-group-type";
    }
}
